import { create, all } from "mathjs";
// 处理浮点数计算精度问题
export const math = create(all, {
  number: "BigNumber",
  precision: 64,
});
